module.exports = __webpack_public_path__ + "img/Feature.3a567322.png";